module.exports = __webpack_public_path__ + "img/TR.7577a3c6.svg";